/* Custom Garden of Juvias */
$(".slick-slider-garden").slick({
  slidesToShow: 4,
  slidesToScroll: 1,
  infinite: true,

  responsive: [
    {
      breakpoint: 510,
      settings: {
        prevArrow:
          '<button type="button" class="slick-prev custom-arrow"><span class="sr-only">Previous</span><svg  xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path class="my-path" xmlns="http://www.w3.org/2000/svg" d="M14,17a1,1,0,0,1-.707-.293l-4-4a1,1,0,0,1,0-1.414l4-4a1,1,0,1,1,1.414,1.414L11.414,12l3.293,3.293A1,1,0,0,1,14,17Z" /></svg></button>',
        nextArrow:
          '<button type="button" class="slick-next custom-arrow"><span class="sr-only">Next</span><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path class="my-path" xmlns="http://www.w3.org/2000/svg" d="M14.707,12.707l-4,4a1,1,0,0,1-1.414-1.414L12.586,12,9.293,8.707a1,1,0,1,1,1.414-1.414l4,4A1,1,0,0,1,14.707,12.707Z" /></svg></button>',

        slidesToShow: 1,
      },
    },
  ],
});

$(".slick-slider-content").slick({
  slidesToShow: 4,
  slidesToScroll: 1,
  infinite: true,
  responsive: [
    {
      breakpoint: 510,
      settings: {
        prevArrow:
          '<button type="button" class="slick-prev custom-arrow"><span class="sr-only">Previous</span><svg  xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path class="my-path" xmlns="http://www.w3.org/2000/svg" d="M14,17a1,1,0,0,1-.707-.293l-4-4a1,1,0,0,1,0-1.414l4-4a1,1,0,1,1,1.414,1.414L11.414,12l3.293,3.293A1,1,0,0,1,14,17Z" /></svg></button>',
        nextArrow:
          '<button type="button" class="slick-next custom-arrow"><span class="sr-only">Next</span><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path class="my-path" xmlns="http://www.w3.org/2000/svg" d="M14.707,12.707l-4,4a1,1,0,0,1-1.414-1.414L12.586,12,9.293,8.707a1,1,0,1,1,1.414-1.414l4,4A1,1,0,0,1,14.707,12.707Z" /></svg></button>',
        slidesToShow: 1,
      },
    },
  ],
});

$(".slick-slider-product").slick({
  slidesToShow: 4,
  slidesToScroll: 1,
  infinite: true,

  responsive: [
    {
      breakpoint: 510,
      settings: {
        prevArrow:
          '<button type="button" class="slick-prev custom-arrow"><span class="sr-only">Previous</span><svg  xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path class="my-path" xmlns="http://www.w3.org/2000/svg" d="M14,17a1,1,0,0,1-.707-.293l-4-4a1,1,0,0,1,0-1.414l4-4a1,1,0,1,1,1.414,1.414L11.414,12l3.293,3.293A1,1,0,0,1,14,17Z" /></svg></button>',
        nextArrow:
          '<button type="button" class="slick-next custom-arrow"><span class="sr-only">Next</span><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path class="my-path" xmlns="http://www.w3.org/2000/svg" d="M14.707,12.707l-4,4a1,1,0,0,1-1.414-1.414L12.586,12,9.293,8.707a1,1,0,1,1,1.414-1.414l4,4A1,1,0,0,1,14.707,12.707Z" /></svg></button>',

        slidesToShow: 1,
      },
    },
  ],
});

$(".mbl-swatch-slide").slick({
  slidesToShow: 10,
  slidesToScroll: 1,
  infinite: true,
  speed: 300,
  responsive: [
    {
      breakpoint: 510,
      settings: {
        prevArrow:
          '<button type="button" class="slick-prev custom-arrow"><span class="sr-only">Previous</span><svg  xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path class="my-path" xmlns="http://www.w3.org/2000/svg" d="M14,17a1,1,0,0,1-.707-.293l-4-4a1,1,0,0,1,0-1.414l4-4a1,1,0,1,1,1.414,1.414L11.414,12l3.293,3.293A1,1,0,0,1,14,17Z" /></svg></button>',
        nextArrow:
          '<button type="button" class="slick-next custom-arrow"><span class="sr-only">Next</span><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path class="my-path" xmlns="http://www.w3.org/2000/svg" d="M14.707,12.707l-4,4a1,1,0,0,1-1.414-1.414L12.586,12,9.293,8.707a1,1,0,1,1,1.414-1.414l4,4A1,1,0,0,1,14.707,12.707Z" /></svg></button>',

        slidesToShow: 4,
        slidesToScroll: 1,
      },
    },
  ],
});

$(document).ready(function () {
  $(".play-button-insta").on("click", function () {
    const video = $(this).parent().parent().find(".video-insta");

    if (video.get(0).paused) {
      video.get(0).play();
      $(this).addClass("play-on-start");
      $(this).html(
        '<svg class="play-off" width="24" height="24"  viewBox="0 0 64 64"><g fill="none" fill-rule="evenodd" id="Pause" stroke="none" stroke-width="1"><path d="M26.5,17 C27.8807119,17 29,18.1192881 29,19.5 L29,44.5 C29,45.8807119 27.8807119,47 26.5,47 C25.1192881,47 24,45.8807119 24,44.5 L24,19.5 C24,18.1192881 25.1192881,17 26.5,17 Z" fill="#000000" id="Rectangle"/><path d="M37.5,17 C38.8807119,17 40,18.1192881 40,19.5 L40,44.5 C40,45.8807119 38.8807119,47 37.5,47 C36.1192881,47 35,45.8807119 35,44.5 L35,19.5 C35,18.1192881 36.1192881,17 37.5,17 Z" fill="#000000" id="Rectangle"/></g></svg>'
      );
    } else {
      video.get(0).pause();
      $(this).removeClass("play-on-start");
      $(this).html(
        '<svg class="play-on" viewBox="0 0 24 24" width="24" height="24"> <path d="M8 5v14l11-7z"></path> </svg>'
      );
    }
  });

  $(".mute-button-insta").on("click", function () {
    const video = $(this).parent().parent().find(".video-insta");

    if (video.get(0).muted) {
      video.get(0).muted = false;
      $(this).html(
        '<svg viewBox="0 0 24 24" width="24" height="24" class="sound-on"> <path d="M3 9v6h4l5 5V4L7 9H3zm13.5 3c0-1.77-1.02-3.29-2.5-4.03v8.05c1.48-.73 2.5-2.25 2.5-4.02zM14 3.23v2.06c2.89.86 5 3.54 5 6.71s-2.11 5.85-5 6.71v2.06c4.01-.91 7-4.49 7-8.77s-2.99-7.86-7-8.77z"></path></svg>'
      );
    } else {
      video.get(0).muted = true;
      $(this).html(
        '<svg width="24" height="24"  id="Layer_1"  viewBox="0 0 50 50" class="sound-off"><line fill="none" stroke="#000000" stroke-linecap="round" stroke-miterlimit="10" stroke-width="2" x1="32" x2="42" y1="20" y2="30"/><line fill="none" stroke="#000000" stroke-linecap="round" stroke-miterlimit="10" stroke-width="2" x1="42" x2="32" y1="20" y2="30"/><rect fill="none" height="50" width="50"/><rect fill="none" height="50" width="50"/><path d="M10,33H3  c-1.103,0-2-0.898-2-2V19c0-1.102,0.897-2,2-2h7" fill="none" stroke="#000000" stroke-linejoin="round" stroke-miterlimit="10" stroke-width="2.08"/><path d="M9.604,32.43  C9.256,32.129,9,31.391,9,30.754V19.247c0-0.637,0.256-1.388,0.604-1.689L22.274,4.926C23.905,3.27,26,3.898,26,6.327v36.988  c0,2.614-1.896,3.604-3.785,1.686L9.604,32.43z" fill="none" stroke="#000000" stroke-linejoin="round" stroke-miterlimit="10" stroke-width="1.9797"/></svg>'
      );
    }
  });

  $("[data-change-varient]").on("click", function () {
    var currentVariant = $(this).attr("data-variant");
    $(".select-tab-cc li.eye-color").removeClass("active");
    $(this).addClass("active");
    $(".image-cc-show .current-image-now").removeClass("active");

    $(
      '.image-cc-show .current-image-now[data-variant="' + currentVariant + '"]'
    ).addClass("active");

    $(this)
      .parent()
      .parent()
      .parent()
      .find(".pp-item-btn")
      .attr("data-variant-id", currentVariant);
    $(this).parent().parent().parent().find("select").val(currentVariant);
  });
  $("[data-change-varient2]").on("change", function () {
    var currentVariant = $(this).val();
    $(".select-tab-cc li.eye-color").removeClass("active");
    $(".image-cc-show .current-image-now").removeClass("active");
    $(
      '.image-cc-show .current-image-now[data-variant="' + currentVariant + '"]'
    ).addClass("active");
    $(
      '.select-tab-cc li.eye-color[data-variant="' + currentVariant + '"]'
    ).addClass("active");
    $(this)
      .parent()
      .parent()
      .parent()
      .find(".pp-item-btn")
      .attr("data-variant-id", currentVariant);
  });

  $("[data-change-varient3]").on("click", function () {
    var currentVariant = $(this).attr("data-variant3");
    $(".select-tab-cc li.lipgel").removeClass("active");
    $(this).addClass("active");
    $(".io-img .current-image-now").removeClass("active");
    $(
      '.io-img .current-image-now[data-varianta="' + currentVariant + '"]'
    ).addClass("active");
    $(this)
      .parent()
      .parent()
      .parent()
      .find(".pp-item-btn-two")
      .attr("data-variant-id", currentVariant);
    $(this).parent().parent().parent().find(".snd-select").val(currentVariant);
  });

  $("[data-change-varient4]").on("change", function () {
    var currentVariant = $(this).val();
    $(".select-tab-cc li.lipgel").removeClass("active");
    $(
      '.select-tab-cc li.lipgel[data-variant3="' + currentVariant + '"]'
    ).addClass("active");
    $(".io-img .current-image-now").removeClass("active");
    $(
      '.io-img .current-image-now[data-varianta="' + currentVariant + '"]'
    ).addClass("active");
    $(this)
      .parent()
      .parent()
      .parent()
      .find(".pp-item-btn-two")
      .attr("data-variant-id", currentVariant);
    $(this).parent().parent().parent().find(".snd-select").val(currentVariant);
  });
});
